export const validateEmployer = (fields) => {
  const isValid = {};

  if (fields?.EmployerName === '') {
    isValid.EmployerName = 'Enter EmployerName';
  }
  if (fields?.EmployerId === '') {
    isValid.EmployerId = 'Enter -';
  }
  if (fields?.OwnerShip === '') {
    isValid.OwnerShip = 'Enter OwnerShip';
  }
  if (fields?.Industry === '') {
    isValid.Industry = 'Enter Industry';
  }
  if (fields?.Address === '') {
    isValid.Address = 'Enter Address';
  }
  if (fields?.HighestSalary === '') {
    isValid.HighestSalary = 'Enter HighestSalary';
  }
  if (fields?.TotalSalaryOutflow === '') {
    isValid.TotalSalaryOutflow = 'Enter TotalSalaryOutflow';
  }
  if (fields?.Website === '') {
    isValid.Website = 'Enter Website';
  }
  if (fields?.SocialMedia === '') {
    isValid.SocialMedia = 'Enter SocialMedia';
  }
  if (fields?.Email === '') {
    isValid.Email = 'Enter Email';
  } else if (!/^[a-zA-Z0-9]+@+[a-zA-Z0-9]+.+[A-z]/.test(fields?.Email)) {
    isValid.Email = 'Enter a valid Email';
  }
  if (fields?.Phone === '') {
    isValid.Phone = 'Enter Phone';
  } else if (fields?.Phone?.length !== 10) {
    isValid.Phone = 'Enter a valid phone number with a maximum of 10 digits';
  }
  if (fields?.SPOCContactInfo === '') {
    isValid.SPOCContactInfo = 'Enter SPOCContactInfo';
  }
  if (fields?.SPOCDesign === '') {
    isValid.SPOCDesign = 'Enter SPOCDesign';
  }

  return isValid;
};
